module.exports = __webpack_public_path__ + "static/img/banner-gw-01.bb82bca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-gw-01.png
// module id = NNza
// module chunks = 2